import React from 'react';

export const BuildingSkyscraper = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52 52"
    fill="none"
    {...props}
  >
    <path
      d="M6.5 45.5H45.5M10.8333 45.5V15.1667L28.1667 6.5V45.5M41.1667 45.5V23.8333L28.1667 15.1667M19.5 19.5V19.5217M19.5 26V26.0217M19.5 32.5V32.5217M19.5 39V39.0217"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
